import _ from 'lodash';
import {allPropertiesFor} from '../utils';

const singleCompFunction = {
    'scrollTo': true
};

function isPropertyFunction(object, property) {
    const descriptor = getDescriptorRecursively(object, property);

    return _.isFunction(descriptor.value);
}

function getDescriptorRecursively(object, property) {
    if (_.isUndefined(object)) {
        return undefined;
    }
    const descriptor = Object.getOwnPropertyDescriptor(object, property);

    return descriptor ? descriptor : getDescriptorRecursively(Object.getPrototypeOf(object), property);
}

function getBatchedResultsFor(batch, property, argumentsForProperty) {
    if (_.get(singleCompFunction, property)) {
        return _.first(batch)[property](...argumentsForProperty);
    }

    return _.map(batch, (batchItem) => batchItem[property](...argumentsForProperty));
}

function setterFunctionFor(batch, property) {
    return function (value) {
        batch.forEach((batchItem) => {
            batchItem[property] = value;
        });
    };
}

function getterFunctionFor(batch, property) {
    if (property === 'style') {
        const batchForDeepProperty = _.without(_.map(batch, (component) => _.get(component, property)), undefined);
        exposeBatch(batchForDeepProperty);

        return function () {
            return batchForDeepProperty;
        };
    }

    return function () {
        return _.first(batch)[property];
    };
}

function defineGetterSetterFor(batch, property, descriptor) {
    const desc = {};

    if (descriptor.get) {
        desc.get = getterFunctionFor(batch, property);
    }

    if (descriptor.set) {
        desc.set = setterFunctionFor(batch, property);
    }

    Object.defineProperty(batch, property, desc);
}

function defineGetterSetter(batch, batchItem, property) {
    const descriptor = getDescriptorRecursively(batchItem, property);

    if (descriptor) {
        defineGetterSetterFor(batch, property, descriptor);
    }
}

function defineBatchFunction(batch, property) {
    batch[property] = function batchFunction(...args) {
        return _.first(getBatchedResultsFor(batch, property, args));
    };
}

function defineBatchFunctionWithMultipleResults(batch, property) {
    batch[property] = function batchFunction(...args) {
        return getBatchedResultsFor(batch, property, args);
    };
}

function exposeBatchAPI(batch, batchItem, prop) {
    if (prop === 'toJSON') {
        defineBatchFunctionWithMultipleResults(batch, prop);
    } else if (isPropertyFunction(batchItem, prop)) {
        defineBatchFunction(batch, prop);
    } else {
        defineGetterSetter(batch, batchItem, prop);
    }
}

function exposeBatch(batch) {
    const componentTypes = _.uniqBy(batch, 'type');
    let properties;
    if (componentTypes.length > 1) {
        const propertiesPerType = [];
        componentTypes.forEach((compType) => {
            const propertiesForType = allPropertiesFor(compType);
            propertiesPerType.push(propertiesForType);
        });
        properties = _.intersection(...propertiesPerType);
    } else {
        properties = allPropertiesFor(_.first(batch));
    }
    properties
        .forEach(exposeBatchAPI.bind(null, batch, _.first(batch)));
}

function expose(components) {
    if (_.isEmpty(components)) {
        return components;
    }

    exposeBatch(components);
    return components;
}

export default {
    expose
};
